import {isNil, isNotNil} from 'ramda';

import {SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';

import {areLeasingBodiesEqual} from './areLeasingBodiesEqual';

export function isLeasingDraftDirty(
  baselineBody: SaveSaleVehicleLeasingBody | null,
  draft: SaveSaleVehicleLeasingBody | null
) {
  return isNotNil(draft) && (isNil(baselineBody) || !areLeasingBodiesEqual(baselineBody, draft));
}
